var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4116)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4844 44H26.7686V36.5645C26.7686 36.3594 26.7715 36.1074 26.7773 35.8086C26.7832 35.5039 26.792 35.1934 26.8037 34.877C26.8154 34.5547 26.8271 34.2646 26.8389 34.0068C26.7744 34.083 26.6426 34.2148 26.4434 34.4023C26.25 34.584 26.0684 34.748 25.8984 34.8945L24.4219 36.0811L23.1123 34.4463L27.252 31.1504H29.4844V44ZM41.9824 37.5752C41.9824 38.6123 41.9004 39.5381 41.7363 40.3525C41.5781 41.167 41.3203 41.8584 40.9629 42.4268C40.6113 42.9951 40.1484 43.4287 39.5742 43.7275C39 44.0264 38.3027 44.1758 37.4824 44.1758C36.4512 44.1758 35.6045 43.915 34.9424 43.3936C34.2803 42.8662 33.791 42.1104 33.4746 41.126C33.1582 40.1357 33 38.9521 33 37.5752C33 36.1865 33.1436 35 33.4307 34.0156C33.7236 33.0254 34.1982 32.2666 34.8545 31.7393C35.5107 31.2119 36.3867 30.9482 37.4824 30.9482C38.5078 30.9482 39.3516 31.2119 40.0137 31.7393C40.6816 32.2607 41.1768 33.0166 41.499 34.0068C41.8213 34.9912 41.9824 36.1807 41.9824 37.5752ZM35.6982 37.5752C35.6982 38.5537 35.751 39.3711 35.8564 40.0273C35.9678 40.6777 36.1523 41.167 36.4102 41.4951C36.668 41.8232 37.0254 41.9873 37.4824 41.9873C37.9336 41.9873 38.2881 41.8262 38.5459 41.5039C38.8096 41.1758 38.9971 40.6865 39.1084 40.0361C39.2197 39.3799 39.2754 38.5596 39.2754 37.5752C39.2754 36.5967 39.2197 35.7793 39.1084 35.123C38.9971 34.4668 38.8096 33.9746 38.5459 33.6465C38.2881 33.3125 37.9336 33.1455 37.4824 33.1455C37.0254 33.1455 36.668 33.3125 36.4102 33.6465C36.1523 33.9746 35.9678 34.4668 35.8564 35.123C35.751 35.7793 35.6982 36.5967 35.6982 37.5752ZM52.2832 37.5752C52.2832 38.6123 52.2012 39.5381 52.0371 40.3525C51.8789 41.167 51.6211 41.8584 51.2637 42.4268C50.9121 42.9951 50.4492 43.4287 49.875 43.7275C49.3008 44.0264 48.6035 44.1758 47.7832 44.1758C46.752 44.1758 45.9053 43.915 45.2432 43.3936C44.5811 42.8662 44.0918 42.1104 43.7754 41.126C43.459 40.1357 43.3008 38.9521 43.3008 37.5752C43.3008 36.1865 43.4443 35 43.7314 34.0156C44.0244 33.0254 44.499 32.2666 45.1553 31.7393C45.8115 31.2119 46.6875 30.9482 47.7832 30.9482C48.8086 30.9482 49.6523 31.2119 50.3145 31.7393C50.9824 32.2607 51.4775 33.0166 51.7998 34.0068C52.1221 34.9912 52.2832 36.1807 52.2832 37.5752ZM45.999 37.5752C45.999 38.5537 46.0518 39.3711 46.1572 40.0273C46.2686 40.6777 46.4531 41.167 46.7109 41.4951C46.9688 41.8232 47.3262 41.9873 47.7832 41.9873C48.2344 41.9873 48.5889 41.8262 48.8467 41.5039C49.1104 41.1758 49.2979 40.6865 49.4092 40.0361C49.5205 39.3799 49.5762 38.5596 49.5762 37.5752C49.5762 36.5967 49.5205 35.7793 49.4092 35.123C49.2979 34.4668 49.1104 33.9746 48.8467 33.6465C48.5889 33.3125 48.2344 33.1455 47.7832 33.1455C47.3262 33.1455 46.9688 33.3125 46.7109 33.6465C46.4531 33.9746 46.2686 34.4668 46.1572 35.123C46.0518 35.7793 45.999 36.5967 45.999 37.5752Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4116",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869347,
    stopColor: "#820375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip100);
export default __webpack_public_path__ + "static/media/chip100.6287cfdef6851e6c13fe92536de4786a.svg";
export { ForwardRef as ReactComponent };